export const mutations = {
  RESET: 'RESET',
  COMMIT_PAGES: 'COMMIT_PAGES',
  UPDATE_PAGE_TITLE: 'UPDATE_PAGE_TITLE',
  RESET_SEARCH_RESULT: 'RESET_SEARCH_RESULT',
  RESET_ASSIGNED_DATA: 'RESET_ASSIGNED_DATA',
  SET_ID_PRODUCT_DYNAMIC: 'SET_ID_PRODUCT_DYNAMIC',
  SET_STATUS_PRODUCT_DYNAMIC: 'SET_STATUS_PRODUCT_DYNAMIC',
  SET_POPUP_ASSIGNED_PRODUCT_ACTIVE: 'SET_POPUP_ASSIGNED_PRODUCT_ACTIVE',
  SET_IS_SHOW_MESSAGE_PUBLISH_POPUP: 'SET_IS_SHOW_MESSAGE_PUBLISH_POPUP',
  UPDATE_IS_ASSIGN_PRODUCT_MODEL: 'UPDATE_IS_ASSIGN_PRODUCT_MODEL',
  UPDATE_IS_INIT_PRELOAD_PRODUCT_SNIPPET: 'UPDATE_IS_INIT_PRELOAD_PRODUCT_SNIPPET',
  UPDATE_IS_USED_PRELOAD_PRODUCT_SNIPPET: 'UPDATE_IS_USED_PRELOAD_PRODUCT_SNIPPET',
  UPDATE_COUNT_PRODUCT_DYNAMIC: 'UPDATE_COUNT_PRODUCT_DYNAMIC',
  RESET_COUNT_PRODUCT_DYNAMIC: 'RESET_COUNT_PRODUCT_DYNAMIC',
};
export const actions = {
  FETCH_PAGES: 'fetchPages',
  GET_ASSIGNED_PRODUCT: 'getAssignedProduct',
};

export const getters = {
  SORTED_PAGES: 'sortedSubPages',
  SORTED_ARTICLE: 'sortedArticlePages',
  SORTED_COLLECTION: 'sortedCollectionPages',
  SORTED_INDEX: 'sortedHomePages',
  SORTED_PRODUCT: 'sortedProductPages',
  GET_ID_PRODUCT_DYNAMIC: 'GET_ID_PRODUCT_DYNAMIC',
  GET_ASSIGNED_PRODUCT_LIST: 'GET_ASSIGNED_PRODUCT_LIST',
  GET_POPUP_ASSIGNED_PRODUCT_ACTIVE: 'GET_POPUP_ASSIGNED_PRODUCT_ACTIVE',
  GET_IS_SHOW_MESSAGE_PUBLISH_POPUP: 'GET_IS_SHOW_MESSAGE_PUBLISH_POPUP',
  GET_PRODUCT_DYNAMIC: 'GET_PRODUCT_DYNAMIC',
  GET_IS_INIT_PRELOAD_PRODUCT_SNIPPET: 'GET_IS_INIT_PRELOAD_PRODUCT_SNIPPET',
  GET_IS_USED_PRELOAD_PRODUCT_SNIPPET: 'GET_IS_USED_PRELOAD_PRODUCT_SNIPPET',
  GET_COUNT_PRODUCT_DYNAMIC: 'GET_COUNT_PRODUCT_DYNAMIC',
  GET_IS_PRODUCT_NOT_FOUND: 'GET_IS_PRODUCT_NOT_FOUND',
};

export class AssignedProductStore {
  public list: any[];
  public cachedList: any[];
  public fetchedAll: boolean;
  public listQuery: any[];
  public cachedListQuery: any[];
  public fetchedAllQuery: boolean;
  public total: number;
  public endCursor: string;
  public endCursorQuery: string;
  public idProductDynamic: any;
  public statusProductDynamic: any;
  public popupAssignedProductActive: boolean;
  public isShowMessagePublishPopup: boolean;
  public isAssignProductModal: boolean;
  public isInitPreloadProductSnippet: boolean;
  public isUsedPreloadProductSnippet: boolean;
  public countProductDynamic: number;

  constructor() {
    this.list = [];
    this.cachedList = [];
    this.fetchedAll = false;
    this.listQuery = [];
    this.cachedListQuery = [];
    this.fetchedAllQuery = false;
    this.total = 0;
    this.endCursor = '';
    this.endCursorQuery = '';
    this.idProductDynamic = 'auto';
    this.statusProductDynamic = '';
    this.popupAssignedProductActive = false;
    this.isShowMessagePublishPopup = true;
    this.isAssignProductModal = false;
    this.isInitPreloadProductSnippet = false;
    this.isUsedPreloadProductSnippet = false;
    this.countProductDynamic = 0;
  }
}

export class PageStore {
  public query: string;
  public fetched: boolean;
  public list: any[];
  public pagination: {
    page: number;
    limit: number;
  };
  public status: {
    loading: boolean;
    success: boolean;
    error: boolean;
  };

  constructor() {
    this.query = '';
    this.fetched = false;
    this.list = [];
    this.pagination = {
      page: 1,
      limit: 5,
    };
    this.status = {
      loading: false,
      error: false,
      success: false,
    };
  }
}

export interface IfGeneralSettingForm {
  title: string;
  handle: string;
  description: string;
  featuredImage: string;
}

export interface IfLayoutSettingForm {
  headerFooter: boolean;
}

export interface IfAdvanceSettingForm {
  lazyLoad: boolean;
}

export interface IfPageSettingForm {
  general: IfGeneralSettingForm;
  layout: IfLayoutSettingForm;
  advance: IfAdvanceSettingForm;
}

export interface IfPageSettingChange {
  // general
  title: boolean;
  handle: boolean;
  description: boolean;
  featuredImage: boolean;
  // layout
  headerFooter: boolean;
  // advance
  lazyLoad: boolean;
}

export const TemplateHandleType: Record<string, string> = {
  'template-index': 'index',
  'template-product': 'product',
  'template-collection': 'collection',
};
